import React from 'react'

import { getAspectRatioPadding } from './utils/getAspectRatioPadding'

import { TIconProps } from './iconProps'

const IconMedal: React.FC<TIconProps> = (props) => {
  return (
    <div style={props.style} className={`select-none ${props.className || 'w-24'}`} onClick={props.onClick}>
      <div className="relative h-0" style={getAspectRatioPadding(props.aspectRatio)}>
        <svg xmlns="http://www.w3.org/2000/svg" className="w-full h-full left-0 top-0 absolute" viewBox="0 0 48 48">
          <g
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M20.008 33.768L16.992 42.057 13.858 37.511 8.535 38.978 13.096 26.446M34.902 26.446L39.465 38.978 34.142 37.511 31.008 42.057 27.991 33.769" />
            <path d="M24 32L20.41 34.564 18.423 30.625 14.053 31.228 14.124 26.817 9.975 25.319 12.087 21.446 9.109 18.192 12.78 15.745 11.655 11.479 16.043 11.018 17.029 6.718 21.128 8.349 24 5 26.872 8.349 30.971 6.718 31.957 11.018 36.345 11.479 35.22 15.745 38.891 18.192 35.913 21.446 38.025 25.319 33.876 26.817 33.947 31.228 29.577 30.625 27.59 34.564z" />
          </g>
        </svg>
      </div>
    </div>
  )
}
export default IconMedal
